import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSaleDetailList, GetSaleDetail, BairunOrderRefund } from '@/api/bairun/saleDetail'; //  此处请自行替换地址

import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { getShiftInfoList } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import OrderStatusTag from '@/components/orderStatusTag';
import SearchTerm from '@/components/searchTerm';
import { Common } from '@/utils/common';
import { mapGetters } from "vuex";

var _this;

export default {
  name: 'GoodsOrderList',
  filters: {
    formatDate: function formatDate(time, format) {
      debugger;

      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, format || 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatDatePayAt: function formatDatePayAt(time) {
      debugger;

      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getPayChannelName: function getPayChannelName(payChannel) {
      for (var i = 0; i < _this.payChannelOption.length; i++) {
        if (_this.payChannelOption[i].payChannel == payChannel) {
          return _this.payChannelOption[i].cnName;
        }
      }

      return '';
    }
  },
  components: {
    OrderStatusTag: OrderStatusTag,
    SearchTerm: SearchTerm
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['asyncStationMap'])),
  data: function data() {
    return {
      listApi: GetSaleDetailList,
      loading: false,
      searchInfo: {
        // 按配置顺序显示
        'sellerOrderType': 2,
        'sellerId': '',
        'shiftDate': '',
        'createdAtStart': '',
        'createdAtEnd': '',
        'mobile': '',
        'mainOrderNo': '',
        'goodsName': '',
        'payChannel': ''
      },
      type: '',
      dialogVisible: false,
      refundDialogVisible: false,
      sellerOrderType: 2,
      payChannelOption: [],
      dateRangeValueArr: [],
      multipleSelection: [],
      formData: {},
      refundFormData: {},
      detailTableData: [],
      orderInfo: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var payChannelList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('GoodsOrderDetail activity init');
                _context3.next = 3;
                return getBairunPayChannelList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 3:
                payChannelList = _context3.sent;
                _this3.payChannelOption = payChannelList.data.list;
                _context3.next = 7;
                return _this3.getDict('orderStatus');

              case 7:
                _context3.next = 9;
                return _this3.getDict('refundStatus');

              case 9:
                _this3.formData = _this3.initData();
                _this3.refundFormData = _this3.initRefundData();

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {};
      return formdata;
    },
    initRefundData: function initRefundData() {
      var formdata = {
        'mainOrderNo': '',
        'tradePay': 0,
        'orderAmount': 0,
        'refundAmount': 0,
        'payChannel': 0
      };
      return formdata;
    },
    // 条件搜索前端看此方法
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;

                _this4.getTableData();

                _this4.loading = false;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onSearchChange: function onSearchChange(formItem) {
      if (formItem.name === 'shiftDate') {
        this.onShiftDateChange(formItem.value);
      }
    },
    onShiftDateChange: function onShiftDateChange(time) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res, minStart, maxEnd;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.searchInfo.sellerId) {
                  _context5.next = 4;
                  break;
                }

                _this5.searchInfo.shiftDate = '';

                _this5.$message({
                  type: 'error',
                  message: '请选择油站'
                });

                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return getShiftInfoList({
                  page: 1,
                  pageSize: 10,
                  stationId: _this5.searchInfo.sellerId,
                  shiftDate: time
                });

              case 6:
                res = _context5.sent;

                if (res.code == 0) {
                  minStart = '';
                  maxEnd = '';
                  res.data.list && res.data.list.forEach(function (item) {
                    if (minStart === '' || new Date(item.startDate) < new Date(minStart)) {
                      minStart = formatTimeToStr(item.startDate, 'yyyy-MM-dd hh:mm:ss');
                    }

                    if (maxEnd === '' || new Date(item.endDate) > new Date(maxEnd)) {
                      maxEnd = formatTimeToStr(item.endDate, 'yyyy-MM-dd hh:mm:ss');
                    }
                  });
                  _this5.searchInfo.createdAtStart = minStart;
                  _this5.searchInfo.createdAtEnd = maxEnd;
                }

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    closeDialog: function closeDialog() {
      this.type = '';
      this.dialogVisible = false;
      this.refundDialogVisible = false;
      this.detailTableData = [];
      this.orderInfo = {};
      this.formData = this.initData();
      this.refundFormData = this.initRefundData();
      this.$forceUpdate();
    },
    onViewDetail: function onViewDetail(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res, orderInfo, orders, activityOrders, activityMap, activityNames, k;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return GetSaleDetail({
                  mainOrderNo: row.mainOrderNo,
                  sellerOrderType: _this6.sellerOrderType,
                  page: 1,
                  pageSize: 99999999
                });

              case 2:
                res = _context6.sent;

                if (!(res.code != 0)) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return");

              case 5:
                orderInfo = JSON.parse(JSON.stringify(row));
                orders = res.data.list.filter(function (item) {
                  return item.tagName == '';
                });
                activityOrders = res.data.list.filter(function (item) {
                  return item.tagName != '';
                });
                _this6.detailTableData = orders.concat(activityOrders);
                activityMap = {};
                activityNames = [];

                _this6.detailTableData.forEach(function (item) {
                  if (item.activityName && item.activityName != '') {
                    activityMap[item.activityName] = item.activityName;
                  }
                });

                for (k in activityMap) {
                  activityNames.push(k);
                }

                orderInfo.activityNames = activityNames;
                _this6.orderInfo = orderInfo;
                _this6.dialogVisible = true;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onRefund: function onRefund() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择要操作的数据'
        });
        return;
      }

      this.refundFormData = JSON.parse(JSON.stringify(this.multipleSelection[0]));
      this.refundFormData.refundAmount = this.refundFormData.tradePay;
      this.refundDialogVisible = true;
      this.type = 'refund';
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    onInputRefundAmount: function onInputRefundAmount(e) {
      this.refundFormData.refundAmount = Common.formatMoney(this.refundFormData.refundAmount);
      this.inputChange(e);
    },
    enterDialog: function enterDialog() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this7.type === 'refund')) {
                  _context7.next = 17;
                  break;
                }

                if (_this7.refundFormData.refundAmount) {
                  _context7.next = 4;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '实退金额不能为空'
                });

                return _context7.abrupt("return");

              case 4:
                if (_this7.refundFormData.payChannel) {
                  _context7.next = 7;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '退款方式不能为空'
                });

                return _context7.abrupt("return");

              case 7:
                if (!(_this7.refundFormData.refundAmount > _this7.refundFormData.orderPay)) {
                  _context7.next = 10;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '实退金额不能大于实付金额'
                });

                return _context7.abrupt("return");

              case 10:
                _context7.next = 12;
                return BairunOrderRefund({
                  'mainOrderNo': _this7.refundFormData.mainOrderNo,
                  'refundAmount': parseFloat(_this7.refundFormData.refundAmount),
                  'refundPayChannel': parseInt(_this7.refundFormData.payChannel)
                });

              case 12:
                res = _context7.sent;

                if (!(res.code == 0)) {
                  _context7.next = 17;
                  break;
                }

                _this7.$message({
                  type: 'success',
                  message: '申请已提交，待审批中'
                });

                _this7.closeDialog();

                return _context7.abrupt("return");

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  }
};